export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";

export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_ERROR = "USER_UPDATE_ERROR";
export const USER_UPDATE_RESET = "USER_UPDATE_RESET";

export const USER_CHANGE_PASS_REQUEST = "USER_CHANGE_PASS_REQUEST";
export const USER_CHANGE_PASS_SUCCESS = "USER_CHANGE_PASS_SUCCESS";
export const USER_CHANGE_PASS_ERROR = "USER_CHANGE_PASS_ERROR";
export const USER_CHANGE_PASS_RESET = "USER_CHANGE_PASS_RESET";